export const RESEND_DEFAULT_AUDIENCE_ID =
  process.env['RESEND_DEFAULT_AUDIENCE_ID'];
